// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"164":"ede83584","237":"3776c4d1","617":"ca335e09","629":"af561b3d","825":"9387cbd7"}[chunkId] + ".chunk.css";
};